module.exports = __webpack_public_path__ + "img/goods11_4.4c470b46.jpg";